<div class="completion-page">
  <img class="completion-check" src="assets/icons/Done.svg" alt="" />
  <div class="completion-copy">
    <h2 class="completion-heading" tabindex="-1" #headingElement>{{ heading() }}</h2>
    <p class="completion-text">{{ message() }}</p>
  </div>
</div>
